import { Component } from 'react';

import ClassImporter from './library/ClassImporter.js';
import Factory from './library/Factory.js';

class App extends Component {

  open(options) {

    window.dataLayer = window.dataLayer || [];

    this.factory = new Factory(ClassImporter, this.props.properties, options.locale, options.redirect_url, options.tracking_context, window.dataLayer, this);
    this.factory.initialiseFactory()
      .then(() => {
        this.factory.getController().showEmailCapturePage();
      });

    this.setState(getOpenState(options, this.factory.getViewBuilder()));

  }

  // Render

  render() {

    return (
      this.state !== null
      && this.state.show
    ) ? this.factory.getViewBuilder().getWidget() : null;

  }

}

let getOpenState = function (options, viewBuilder) {

  return {
    actionInProgress: false,
    show: true,
    emailAddress: undefined,
    password: undefined,
    formError: undefined,
    emailAddressErrorMessage: undefined,
    passwordErrorMessage: undefined,
    view: viewBuilder.getLoadingAppView,
    onSuccess: options.onSuccess,
    onFailure: options.onFailure
  };

};

export default App;



// WEBPACK FOOTER //
// ./src/App.js